import { render } from "./LoadIcon.vue.js?vue&type=template&id=2ee603e2!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./LoadIcon.vue?vue&type=template&id=2ee603e2"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__